import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { Fish } from '../types/fish';

type FishResponse = Fish;
type DefaultError = unknown;

type UseFishParams = {
  fishId?: string;
  enabled?: boolean;
};

export function useFish<TData = FishResponse, TError = DefaultError>(
  { fishId, enabled = true }: UseFishParams = {},
  options?: Omit<
    UseQueryOptions<FishResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryKey: QueryKey = ['fish', fishId];

  return useQuery<FishResponse, TError, TData>({
    queryKey,
    enabled: enabled && !!fishId,
    queryFn: async () => {
      if (!fishId) {
        throw new Error('fishId is required to fetch a fish');
      }

      const response = (await service.readFishById(fishId)) as Fish;

      return response;
    },
    ...(options as UseQueryOptions<FishResponse, TError, TData, QueryKey>),
  });
}
